import {
  Card, CardContent, Typography, Chip, Box,
  Table, TableHead, TableRow, TableCell, TableBody,
} from '@mui/material'
import {
  getDisplayStatus, getEntrySides, getEntryOwners, getSiteCount, getOverdueDays,
} from '../utils/aggregate'
import { VENDOR_COLORS } from './charts/palette'

// Top atividades em atraso, ordenadas por dias de atraso.
export default function RiskTable({ rows }) {
  const risk = rows
    .filter((r) => getDisplayStatus(r) === 'Overdue')
    .map((r) => ({ r, days: getOverdueDays(r) }))
    .sort((a, b) => b.days - a.days)
    .slice(0, 8)

  return (
    <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 3, mt: 2 }}>
      <CardContent sx={{ p: '14px 16px !important' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
          <Typography sx={{ fontSize: 13, fontWeight: 600 }}>At-risk / overdue activities</Typography>
          <Chip size="small" label={`${rows.filter((r) => getDisplayStatus(r) === 'Overdue').length} need attention`} sx={{ bgcolor: '#fdecec', color: '#c62828' }} />
        </Box>

        {risk.length === 0 ? (
          <Typography sx={{ fontSize: 13, color: 'text.disabled', textAlign: 'center', py: 2 }}>
            No at-risk activities for this filter.
          </Typography>
        ) : (
          <Table size="small">
            <TableHead>
              <TableRow>
                {['Activity', 'Team', 'Vendor', 'Side', 'Owner', 'Sites', 'Late'].map((h, i) => (
                  <TableCell key={h} align={i >= 5 ? 'right' : 'left'} sx={{ color: 'text.secondary', fontSize: 12, fontWeight: 500, border: 0 }}>{h}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {risk.map(({ r, days }) => {
                const vc = VENDOR_COLORS[r.vendor]
                return (
                  <TableRow key={r.id}>
                    <TableCell sx={{ fontSize: 13, maxWidth: 220, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={r.title}>{r.title}</TableCell>
                    <TableCell sx={{ fontSize: 13, color: 'text.secondary' }}>{r.teamName || '—'}</TableCell>
                    <TableCell>
                      <Chip size="small" label={r.vendor || '—'} sx={{ bgcolor: vc ? `${vc}22` : 'grey.100', color: vc || 'text.secondary', fontSize: 12 }} />
                    </TableCell>
                    <TableCell sx={{ fontSize: 13, color: 'text.secondary' }}>{getEntrySides(r).join(', ') || '—'}</TableCell>
                    <TableCell sx={{ fontSize: 13, color: 'text.secondary', maxWidth: 140, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{getEntryOwners(r).join(', ') || '—'}</TableCell>
                    <TableCell align="right" sx={{ fontSize: 13, color: 'text.secondary' }}>{getSiteCount(r)}</TableCell>
                    <TableCell align="right" sx={{ fontSize: 13, fontWeight: 600, color: '#c62828' }}>{days}d</TableCell>
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  )
}
